import { render, staticRenderFns } from "./yarn_stock_report.vue?vue&type=template&id=87bc20da&scoped=true"
import script from "./yarn_stock_report.vue?vue&type=script&lang=js"
export * from "./yarn_stock_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bc20da",
  null
  
)

export default component.exports